import React from 'react';
import {connect} from "react-redux";
import {Card, Divider, Row, Switch} from "antd";
import {getMyProfile, updateNotificationSettings} from "../../actions/users";
import {compose} from "redux";
import {withBreadcrumbCurried} from "../Boilerplate/BreadcrumbContext";
import {withLoading} from "../Boilerplate/deferLoaderHoc";
import * as R from 'ramda';

const EmailNotification = ({ setEmailNotification, ...settings }) => {
  return (
    <Card
      className='email-notification'
      title={<h1>Email Notification</h1>}
    >
      <div>
        <Divider orientation='left'>Bid Notifications</Divider>
        <Row>
          <Switch
            key="emailsettingbidinviteson"
            checked={settings.emailsettingbidinviteson}
            onChange={checked => setEmailNotification(R.assoc('emailsettingbidinviteson', checked, settings))}
          /> Bid Invitations
        </Row>
        <Row>
          <Switch
            key="emailsettingbidactivityon"
            checked={settings.emailsettingbidactivityon}
            onChange={checked => setEmailNotification(R.assoc('emailsettingbidactivityon', checked, settings))}
          /> Bid Activity Updates
        </Row>
        <Row>
          <Switch
            key="emailsettingprebidon"
            checked={settings.emailsettingprebidon}
            onChange={checked => setEmailNotification(R.assoc('emailsettingprebidon', checked, settings))}
          /> Pre Bid Notifications
        </Row>
      </div>
      <div>
        <Divider orientation='left'>Project Notifications</Divider>
        <Row>
          <Switch
            key="emailsettingprojectinviteson"
            checked={settings.emailsettingprojectinviteson}
            onChange={checked => setEmailNotification(R.assoc('emailsettingprojectinviteson', checked, settings))}
          /> Project Invitations
        </Row>
        <Row>
          <Switch
            key="emailsettingprojectactivityon"
            checked={settings.emailsettingprojectactivityon}
            onChange={checked => setEmailNotification(R.assoc('emailsettingprojectactivityon', checked, settings))}
          /> Project Activity Updates
        </Row>
        <Row>
          <Switch
            key="emailsettingprojectdailylogon"
            checked={settings.emailsettingprojectdailylogon}
            onChange={checked => setEmailNotification(R.assoc('emailsettingprojectdailylogon', checked, settings))}
          /> Project Daily Log Updates
        </Row>
      </div>
    </Card>
  );
};

export default compose(
  withBreadcrumbCurried({ title: 'Email Notification', path: '/settings/email-notification'}),
  connect(
    (state, ownProps) => {
      if (R.isEmpty(state.profile)) {
        return {
          loading: true
        };
      }
      return R.pickBy((v,k) => k.startsWith('emailsetting'), state.profile);
    },
    (dispatch, ownProps) => ({
      setEmailNotification: (settings) => dispatch(updateNotificationSettings(settings)),
      loader: () => dispatch(getMyProfile())
    })
  ),
  withLoading
)(EmailNotification);



// WEBPACK FOOTER //
// ./src/components/Settings/EmailNotification.js